import gql from 'graphql-tag';

export const GET_EMAIL_TEMPLATES = gql`
  query GetEmailTemplates {
    getEmailTemplates {
      id
      name
      purpose
      subject
      triggerEvent
      isActive
      createdAt
      updatedAt
      stats {
        id
        sentCount
        openCount
        clickCount
        bounceCount
        lastSentAt
      }
    }
  }
`;

export const GET_EMAIL_TEMPLATE = gql`
  query GetEmailTemplate($id: ID!) {
    getEmailTemplate(id: $id) {
      id
      name
      purpose
      subject
      body
      triggerEvent
      isActive
      createdAt
      updatedAt
      stats {
        id
        sentCount
        openCount
        clickCount
        bounceCount
        lastSentAt
      }
    }
  }
`;

export interface EmailTemplateStatsGql {
  id: string;
  sentCount: number;
  openCount: number;
  clickCount: number;
  bounceCount: number;
  lastSentAt: number | null;
}

export interface EmailTemplateListItem {
  id: string;
  name: string;
  purpose: string;
  subject: string;
  triggerEvent: string;
  isActive: boolean;
  createdAt: number;
  updatedAt: number;
  stats: EmailTemplateStatsGql;
}

export interface GetEmailTemplatesResponse {
  getEmailTemplates: EmailTemplateListItem[];
}

export interface EmailTemplateDetail extends EmailTemplateListItem {
  body: string;
}

export interface GetEmailTemplateResponse {
  getEmailTemplate: EmailTemplateDetail | null;
}
